import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AddPaymentDropinComponent } from './add-payment-dropin.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AddPaymentDropinComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule.forChild(),
    RouterModule.forChild([{ path: '', component: AddPaymentDropinComponent }])
  ]
})
export class AddPaymentDropinModule {}
